module.exports = __webpack_public_path__ + "static/media/arrow-right-blue.43876b2e.svg";